<template>
  <div>
    <!-- <div v-if="type != '' && type == 1">
      <div class="personnel-banner"></div>
      <div class="personnel-content">
        <img class="personnel-top" src="https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/applet/per-gift.png" alt="" />
        <img class="personnel-second" src="https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/applet/store-bonus.png" alt="" />
        <img class="personnel-third" src="https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/applet/promoter.png" alt="" />
        <img class="personnel-four" src="https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/applet/promote-teach.png" alt="" />
        <img class="personnel-five" src="https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/applet/active-rule.png" alt="" />
      </div>
      <div class="personnel-btn">
        <van-button class="right" type="primary" @click="to_form">我要成为推广员</van-button>
      </div>
    </div>
    <div v-else-if="type != '' && type == 2">
      <div class="promote-banner"></div>
      <div class="promote-content">
        <img class="content-1" src="https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/landing_h5/h5_store_1.png" alt="" />
        <img class="content-2" src="https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/landing_h5/h5_store_2.png" alt="" />
        <img class="content-3" src="https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/landing_h5/h5_store_3.png" alt="" />
        <img class="content-4" src="https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/landing_h5/h5_store_4.png" alt="" />
        <img class="content-5" src="https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/landing_h5/h5_store_5.png" alt="" />
        <img class="content-6" src="https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/landing_h5/h5_store_6.png" alt="" />
        <img class="content-7" src="https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/landing_h5/h5_store_7.png" alt="" />
      </div>
      <div class="promote-wrap" @click="to_form">
        <div class="promote-btn"></div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { Button } from 'vant';
import { toRefs, reactive, onMounted } from 'vue';
import { get } from '../../../request/http';
import { useRoute, useRouter } from 'vue-router'

export default {
  components: {
    [Button.name]: Button,
  },

  setup() {
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      share_id: '', // 分享id
      invite_code: '',  // 邀请码
      type: '', // 类型，开店、推广员
    });

    const get_share_info = (id) => {
      const params = { share_id: id }
      
      get('/api/share/info', params).then( res => {
        state.invite_code = res.data.data.invite_code
        state.type = res.data.data.type
        // if (res.data.data.from_type == 2) {
        router.push({ path: '/form', query: { parent_invite_code: res.data.data.invite_code, share_id: state.share_id }})
        // }
      })
    }

    // 跳转
    const to_form = () => {
      router.push({ path: '/form', query: { parent_invite_code: state.invite_code, share_id: state.share_id }})
    }

    onMounted(() => {
      if (route.query.share_id) {
        state.share_id = route.query.share_id
        get_share_info(route.query.share_id);
      } else {
        router.push({ path: '/form', query: { parent_invite_code: route.query.parent_invite_code }})
      }
    })

    return {
      to_form,
      get_share_info,
      ...toRefs(state)
    };
  }

};
</script>

<style lang="less">
.promote {
  &-content {
    width: 100%;
    .content-1 {
      width: 100%;
    }

    .content-2 {
      width: 100%;
      margin-top: -0.5rem;
    }

    .content-3 {
      width: 100%;
      margin-top: -0.5rem;
    }

    .content-4 {
      width: 100%;
      margin-top: -0.5rem;
    }

    .content-5 {
      width: 100%;
      margin-top: -0.5rem;
    }

    .content-6 {
      width: 100%;
      margin-top: -0.5rem;
    }

    .content-7 {
      width: 100%;
      margin-top: -0.5rem;
    }
  }

  &-wrap {
    width: 100%;
    height: 10rem;
    background: #FA5C00;
    position: fixed;
    bottom: 0;
  }

  &-btn {
    width: 32.3rem;
    height: 6rem;
    background: url(https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/landing_h5/h5_store_btn.png) no-repeat;
    background-size: 100% 100%;
    margin: 0.5rem auto;
  }
}

.personnel {
  &-banner {
    width: 100%;
    height: 35.6rem;
    background: url('https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/applet/per-banner.png') no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    overflow: auto;
  }

  &-content {
    width: 100%;
    min-height: 194.5rem;
    position: relative;
    background: linear-gradient(139deg, #ff8e2d, #ff4c3e 77%);
    padding-bottom: 2rem;

    .personnel-top {
      width: 33.5rem;
      height: 22.6rem;
      display: block;
      margin: auto; 
      position: absolute; 
      top: -13.5rem;
      left: 0;
      right: 0;
    }

    .personnel-second {
      width: 33.5rem;
      height: 36.7rem;
      display: block;
      margin: auto; 
      position: absolute; 
      top: 11rem;
      left: 0;
      right: 0;
    }

    .personnel-third {
      width: 33.5rem;
      height: 44rem;
      display: block;
      margin: auto; 
      position: absolute; 
      top: 49.7rem;
      left: 0;
      right: 0;
    }

    .personnel-four {
      width: 33.5rem;
      height: 83rem;
      display: block;
      margin: auto; 
      position: absolute; 
      top: 95.7rem;
      left: 0;
      right: 0;
    }

    .personnel-five {
      width: 33.5rem;
      height: 14.1rem;
      display: block;
      margin: auto; 
      position: absolute; 
      bottom: 2rem;
      left: 0;
      right: 0;
    }
  }

  &-btn {
    margin: 1.4rem 0;
    text-align: center;
    button {
      width: 34.3rem;
      height: 4.5rem;
      border: none;
      font-size: 1.6rem;
      color: #FFF;
      background: #fa6400;
      border-radius: 0.4rem;
    }
  }
}
</style>
